import { WithStatelessDatasFetching } from 'modules/shared/hocs';
import { Brand } from '../../models';
import { brandService } from '../../services';

import { BrandsProps } from '.';
import { BrandsLoader } from './brands-page-loader';

const enhancer = WithStatelessDatasFetching<Brand[], BrandsProps>(brandService.getAll, BrandsLoader, 'error', 'brands');

export default enhancer;
